export const menuCellRules = {
	'menu-cell': params => {
		if (params.data) {
			return params.data.Menu;
		}
	},
};
